import noUISlider from 'nouislider'


class Range {
  constructor(element) {
    this.element = element;
    this.range = this.$element.find('.range')[0];
    this.min = (this.$element.data('min'));
    this.max = (this.$element.data('max'));
    this.step = this.$element.data('step') || 1;
    this.minInput = this.$element.find('.input.min');
    this.maxInput = this.$element.find('.input.max');
    this.minLabel = this.$element.find('.label.min span');
    this.maxLabel = this.$element.find('.label.max span');

    this.init();
  }

  get $element() {
    return $(this.element);
  }


  static create(element) {
    return new Range(element);
  }

  init() {
    noUISlider
      .create(this.range, {
        start: [
          this.minInput.val(),
          this.maxInput.val(),
        ],
        connect: true,
        step: this.step,
        range: {
          'min': this.min,
          'max': this.max,
        }
      })
      .on('update', (value) => {
        this.setValue(value[0], value[1]);
      });
    this.setValue(this.minInput.val(), this.maxInput.val());
  }

  setValue(min, max) {
    this.minLabel.text(min);
    this.maxLabel.text(max);
    this.minInput.val(min);
    this.maxInput.val(max);
  }
}

$('.range-input').each((index, range) => {
  Range.create(range);
});





// WEBPACK FOOTER //
// ./src/js/components/range.js